<template>
  <destination-form />
</template>

<script>
import DestinationForm from '@/components/forms/DestinationForm'
export default {
  components: {
    DestinationForm
  }
}
</script>
